import { Version } from '@angular/core';

import { WchSdkVersion } from './../../../../api';
import { VERSION } from './../../../version';

/* Copyright IBM Corp. 2017 */
export interface SdkVersion extends WchSdkVersion {
    readonly version: Version;
    readonly build: Date;
}

/*
 * Exposes the SDK version
 */
export const SDK_VERSION: SdkVersion = {
    version: new Version(VERSION.version),
    build: new Date(VERSION.build)
};
